import React, { useState, useCallback, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomerTabs from "../set-bar.js";
import { Row, Col } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Toast, ToastContainer } from "react-bootstrap";
import {
  getDeleteFieldsApi,
  getFieldListApi,
  getListApi,
} from "./alertconfiguration-api.js";

//Images
import back from "../../../assets/svg/backarrow.svg";
import search from "../../../assets/svg/search.svg";
import df from "../../../assets/svg/df.svg";
import plus from "../../../assets/svg/plus.svg";
import edit from "../../../assets/svg/edit.svg";
import del from "../../../assets/svg/delete.svg";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import mawalog from "../../../assets/svg/mawaloglogo.svg";
import CustomerButtons from "../excel-upload-download.js";

const Alertconfiguration = () => {
  const navigate = useNavigate();
  const alertRef = useRef(null);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [activeTab, setActiveTab] = useState("alertconfigurations");
  const [count, setCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortDir, setSortDir] = useState("");
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [alertList, setAlertList] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  const deleteModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "40px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 1)",
      width: "436px",
      height: "228px",
      textAlign: "center",
    },
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);

    if (value) {
      const [field, dir] = value.split(" ");
      setSortField(field);
      setSortDir(dir);
    } else {
      setSortField(""); // Default sort
      setSortDir("");
    }
  };
  const safeValue = (value) => {
    return value === null || value === undefined || value === "" ? "-" : value;
  };

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const deleteDialog = async (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  //Delete API
  const deleteApi = async () => {
    if (deleteId != null) {
      const response = await getDeleteFieldsApi(deleteId);
      if (response.status === 200) {
        if (response.data.success === true) {
          setDeleteId(null);
          setIsOpenDelete(false);
          getAlertList();
        }
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
      }
    }
  };

  //Get
  useEffect(() => {
    getAlertList();
  }, [itemsPerPage, itemOffset, searchText, sortField, sortDir]);

  const getAlertList = async () => {
    try {
      const searchParams = new URLSearchParams({
        search: searchText,
        limit: itemsPerPage.toString(),
        skip: (itemOffset * itemsPerPage).toString(),
        sortByField: sortField,
        sortBy: sortDir,
      }).toString();

      const response = await getListApi(`?${searchParams}`);
      if (response.data?.success === true) {
        setAlertList(response.data.data || []);
        setPageCount(Math.ceil(response.data.total_rec / itemsPerPage));
        setCount(response.data.total_rec);
      } else {
        setSnackbarMessage("Failed to fetch alert configurations");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching alerts:", err);
      setSnackbarMessage("Error fetching alert configurations");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };
  const onFileResponse = (response) => {
    getAlertList();
    console.log(response);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
  };
  return (
    <div className="customer-container mb-2">
      <div className="customer-header">
        <div
          className="customer-back-button"
          onClick={() => {
            navigate(-1);
          }}
        >
          <img src={back} alt="Back" className="customer-backicon" />
        </div>
        <h1>Admin Setup</h1>
      </div>
      <div className="customer-card">
        <CustomerTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        <div className="top-bar flex flex-col md:flex-row md:items-center md:justify-between">
          <h2 className="title">
            {"Alert Configuration"} ({count})
          </h2>

          <div className="action-group w-full md:w-auto">
            <div className="toolbar flex flex-col md:flex-row flex-wrap items-stretch">
              {/* Search Box */}
              <div className="search-box flex items-center border rounded-md w-full md:w-auto">
                <span className="icon mr-2">
                  <img
                    src={search}
                    alt="search"
                    className="search-icon w-4 h-4"
                  />
                </span>
                <input
                  type="text"
                  placeholder="Search"
                  className="outline-none w-full"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>

              {/* Sort Dropdown */}
              <button
                className="btn rounded-3 me-2"
                style={{ borderColor: "#dcdfe4" }}
              >
                <img src={df} />
                <select
                  style={{
                    outline: "none",
                    border: "none",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#172B4D",
                  }}
                  value={selectedValue}
                  onChange={handleChange}
                >
                  <option value="">Default (data created)</option>
                  <option value="name asc">Name (Asc)</option>
                  <option value="name desc">Name (Dsc)</option>
                  <option value="created asc">Date (Oldest)</option>
                  <option value="created desc">Date (Newest)</option>
                </select>
              </button>

              <CustomerButtons
                activeTab={activeTab}
                responseMsg={onFileResponse}
                isTemplate={true}
                isUpload={true}
                isDownload={true}
              />
              {/* Add Button */}
              <button
                className="addbtn bttn flex items-center  bg-blue-600 text-white rounded-md"
                onClick={() => navigate("/alertconfigurations/add")}
              >
                <span className="icon">
                  <img src={plus} alt="add" className="btn-icon w-4 h-4" />
                </span>
                Add
              </button>
            </div>
          </div>
        </div>

        <div className="table-container">
          {activeTab === "alertconfigurations" && (
            <table className="dock-table">
              <thead>
                <tr>
                  <th>SI.No</th>
                  <th>Code</th>
                  <th>Field Name</th>
                  <th>Dock</th>
                </tr>
              </thead>
              <tbody>
                {alertList?.map((row, index) => (
                  <tr key={"transport" + index}>
                    <td>{itemOffset * itemsPerPage + (index + 1)}</td>
                    <td>{safeValue(row.code)}</td>
                    <td>{safeValue(row.name)}</td>
                    <td className="hover-time-cell group">
                      {safeValue(row.docks_name)}
                      <div className="time-actions">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();

                            navigate("/alertconfigurations/add", {
                              state: { dockId: row.id },
                            });
                          }}
                          className="icon-btn edit-btn"
                          title="Edit"
                        >
                          <img src={edit} alt="Edit" className="icon-img" />
                        </button>
                        <button
                          onClick={(e) => {
                             e.stopPropagation();
                            deleteDialog(row.id);
                          }}
                          className="icon-btn delete-btn"
                          title="Delete"
                        >
                          <img src={del} alt="Delete" className="icon-img" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        <Row style={{ marginTop: "16px" }}>
          <Col>
            <div className="d-flex align-items-center justify-content-start mx-3">
              <span
                style={{
                  fontFamily: "Epilogue",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#212129",
                }}
              >
                Records per page :
              </span>
              <select
                className="select3"
                id="perpage"
                value={itemsPerPage}
                onChange={(event) => setItemsPerPage(event.target.value)}
                style={{
                  cursor: "pointer",
                  fontFamily: "Epilogue",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18.9px",
                  color: "#212129",
                  width: "56px",
                  height: "24px",
                  borderRadius: "10px",
                  border: "0.7px solid #E5E5E5",
                  padding: "0 4px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </Col>
          <Col>
            <div className="d-flex justify-content-end">
              <ReactPaginate
                previousLabel={<img src={lar} className="ar3" alt="previous" />}
                nextLabel={<img src={rar} className="ar3" alt="next" />}
                breakLabel={"..."}
                pageCount={pageCount + 1}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            </div>
          </Col>
        </Row>

        <div
          style={{
            textAlign: "center",
            marginTop: "30px",
            fontWeight: "400",
            fontSize: "12px",
            color: "#172B4D",
          }}
        >
          Powered by{" "}
          <span>
            <img src={mawalog} />
          </span>
        </div>
      </div>

      {isOpenDelete && (
        <div style={deleteModalStyle.overlay} backdrop="static">
          <div ref={alertRef} style={deleteModalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#1E1E1E",
                  }}
                >
                  Delete{" "}
                </div>
                <div
                  style={{
                    marginTop: "8px",
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "#1E1E1E",
                  }}
                >
                  You won’t able to access your record after deleting. Are you
                  sure want to delete?
                </div>

                <div
                  style={{
                    flex: 12,
                    marginTop: "8px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "start",
                    justifyContent: "start",
                  }}
                >
                  <div
                    onClick={() => {
                      setIsOpenDelete(false);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "158px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "8px",
                      display: "flex",
                      flex: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #E5E5E5",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#1E1E1E",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      deleteApi();
                    }}
                    style={{
                      cursor: "pointer",
                      width: "158px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "8px",
                      display: "flex",
                      flex: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#FF4444",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#FFFFFF",
                      }}
                    >
                      Delete
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Alertconfiguration;
